import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { AuthService, currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class TeamMemberService {
  private authToken;
  private company_id;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  findTeamMembers(queryParams: QueryParamsModel, category_id): Observable<QueryResultsModel> {
    if (!category_id) {
      return of(null);
    }
    const url = `${environment.USER_BASE}/companies/${this.company_id}/category/${category_id}/members`;
    const params = this.httpUtils.getFindHTTPParams(queryParams);
    return this.http.get<any>(url, { params });
  }

  teamManagersAutocomplete(roles, term?): Observable<any> {
    if (roles?.length === 0) {
      return of([]);
    }
    let fromString = '';
    roles?.forEach((role) => (fromString += `&role_id=${role.id}`));
    const params = new HttpParams({ fromString });
    const url = `${environment.USER_BASE}/autocomplete-user?term=${term}&is_active=true`;
    return this.http.get<any>(url, { params });
  }
}
